export default function NoopAnalytics() {
  return {
    sendEvent() {},
    sendPage() {}
  };
}
